var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telephone 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.0213 58.9727C64.2332 56.2202 60.7527 56.2202 57.9824 58.9727C55.8692 61.068 53.756 63.1634 51.6783 65.2943C51.1101 65.8803 50.6306 66.0046 49.938 65.614C48.5707 64.8682 47.1145 64.2644 45.8004 63.4476C39.6739 59.5942 34.5418 54.6398 29.9957 49.0639C27.7405 46.2938 25.7338 43.3283 24.3309 39.9898C24.0468 39.315 24.1001 38.8711 24.6506 38.3206C26.7638 36.2785 28.8237 34.1831 30.9014 32.0877C33.796 29.1755 33.796 25.766 30.8837 22.836C29.2322 21.1668 27.5807 19.5331 25.9292 17.8639C24.2244 16.1592 22.5374 14.4367 20.8148 12.7497C18.0268 10.0328 14.5463 10.0328 11.776 12.7675C9.64504 14.8629 7.60287 17.0116 5.43639 19.0714C3.42973 20.9715 2.41752 23.2977 2.20442 26.0146C1.86702 30.4363 2.95026 34.6093 4.47745 38.6758C7.60287 47.0929 12.362 54.5688 18.1334 61.4232C25.9292 70.6926 35.2344 78.0265 46.12 83.3183C51.0213 85.6978 56.1001 87.5268 61.6228 87.8287C65.423 88.0418 68.726 87.0829 71.372 84.1174C73.1833 82.093 75.2255 80.2462 77.1433 78.3106C79.9846 75.4339 80.0024 71.9534 77.1788 69.1122C73.8048 65.7205 70.413 62.3466 67.0213 58.9727Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.184 45L70.7143 43.8607C69.6878 37.7305 66.8563 32.179 62.5558 27.7667C58.0076 23.1193 52.2559 20.1899 45.9203 19.2857L45 25.9946C49.9022 26.6998 54.3619 28.9602 57.8837 32.5588C61.2108 35.9584 63.3876 40.2622 64.184 45Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.052 16.1676C66.3745 8.48822 56.6605 3.63906 45.9372 2.14285L45 8.83073C54.2635 10.1286 62.6619 14.3289 69.2941 20.9446C75.5839 27.2359 79.711 35.1857 81.2069 43.9286L87.8571 42.7929C86.109 32.6619 81.3331 23.4683 74.052 16.1676Z",
    fill: "#52682F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.87ff6065901161540467b94da94d72ef.svg";
export { ForwardRef as ReactComponent };